<template>
  <div class="plus-line" style="width: 100%">
    <v-row
      no-gutters
      justify="center"
      :class="{ 'line-css': true, 'default-add': !special || !batch, 'special-add': special || inner, 'catch-add': catchType, 'batch-add': batch }"
    >
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <div
            :class="{ 'plus-css': true, 'default-add-plus': !special || !batch, 'special-add': special || inner, 'catch-add plus-css-catch-type': catchType, 'batch-add': batch }"
            v-bind="props"
          >
            +
          </div>
        </template>
        <span v-if="inner">{{ tooltip('inner') }}</span>
        <span v-else-if="special">{{ tooltip('special') }}</span>
        <span v-else-if="batch">{{ tooltip('batch') }}</span>
        <span v-else-if="catchType">{{ tooltip('exception') }}</span>
        <span v-else>{{ tooltip() }}</span>
      </v-tooltip>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    special: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    batch: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    inner: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    catchType: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  methods: {
    tooltip(type) {
      switch (type) {
      case 'inner':
        return this.$lang.labels.childStep
      case 'special':
        return this.$lang.labels.query
      case 'batch':
        return this.$lang.labels.batch
      case 'exception':
        return this.$lang.labels.exception
      default:
        return this.$lang.labels.step
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.plus-line {
  position: relative;
  height: 22px;
}

.line-css {
  width: 100%;
  height: 1px;
  position: absolute;
  top: 12px;
  inset-inline-start: 0;
}

.plus-css {
  cursor: pointer;
  height: 16px;
  width: 16px;
  position: absolute;
  top: -8px;
  inset-inline-start: 20px;
  font-size: 15px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &-catch-type {
    color: black;
  }
}

.default-add-plus {
  background-color: rgb(var(--v-theme-timelineBg));
  color: rgb(var(--v-theme-textbase));
}

.default-add {
  background-color: rgb(var(--v-theme-primary));
}

.special-add {
  background-color: rgb(var(--v-theme-warning));
  color: black;
}

.batch-add {
  background-color: rgb(var(--v-theme-warning));
  color: black;
}

.inner-add {
  background-color: rgb(var(--v-theme-error));
}

.catch-add {
  background-color: rgb(var(--v-theme-warning));
  color: black;
}
</style>
